import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useIntl } from "../../contexts/IntlContext";
import LoadingButton from "../ui/LoadingButton";
import { memo } from "react";

type Props = {
  open: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Opcional — quando omitido, herda o default do tema (small). */
  size?: "small" | "medium";
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmDialog = memo(function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  size,
  onConfirm,
  onClose,
}: Props) {
  const intl = useIntl();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      fullScreen={false}
      fullWidth={fullScreen}
      maxWidth="xs"
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{ px: { xs: 2, sm: 3 }, pt: { xs: 2, sm: 3 }, pb: 1 }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 2, sm: 3 }, pb: 0 }}>
        <DialogContentText sx={{ wordBreak: "break-word" }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          px: { xs: 2, sm: 3 },
          pb: { xs: 2, sm: 3 },
          pt: 1,
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <LoadingButton onClick={onClose} variant="text" size={size} fullWidth={false}>
          {cancelLabel || intl.formatMessage({ id: "common.cancel" })}
        </LoadingButton>
        <LoadingButton onClick={onConfirm} variant="contained" color="primary" size={size} fullWidth={false}>
          {confirmLabel || intl.formatMessage({ id: "common.confirm" })}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
});

export default ConfirmDialog;
